export default {
  401() {
    // location.href = `${process.env.VUE_APP_Base}/401`
  },
  404() {
    // location.href = `${process.env.VUE_APP_Base}/404`
  },
  500() {
    // location.href = `${process.env.VUE_APP_Base}/500`
  }
}
